import React from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-purple-200 selection:text-purple-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBanner data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <FeaturesSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <SocialProofPopup data-id="element-14" />

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-xs" data-id="element-15">
        <div className="max-w-4xl mx-auto px-4" data-id="element-16">
          <p data-id="element-17">© 2024 Mega Pack Terapéutico. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-18">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>
    </div>;
}